import { ASSET } from '@/modules/wallet/types';

import VoteIcon from '@/components/Header/images/vote.svg?react';
import Algo from '@/shared/icons/tokens/algo.svg?react';
import MyIcon from '@/shared/icons/tokens/my.svg?react';
import Ton from '@/shared/icons/tokens/ton.svg?react';
import TonBig from '@/shared/icons/tokens/ton.svg?react';
import Usdc from '@/shared/icons/tokens/usdc.svg?react';
import Usdt from '@/shared/icons/tokens/usdt.svg?react';
import UsdtBig from '@/shared/icons/tokens/usdt.svg?react';
import Vote from '@/shared/icons/voteSmall.svg?react';

export const JETTON_ID = import.meta.env.VITE_DEPOSIT_JETTON_ID;
export const INDEXER_ADDRESS = import.meta.env
  .VITE_CONFIG_INDEXER_DESTINATION_ADDRESS;

export const ALGO_INDEXER_ADDRESS = import.meta.env
  .VITE_CONFIG_INDEXER_ALGO_DESTINATION_ADDRESS;

export const SORTING_WALLET = {
  ASC: 'createdAt.asc',
  DESC: 'createdAt.desc',
};

export enum SORTING_POLLS {
  ASC = 'asc',
  DESC = 'desc',
  VOTERS = 'voters',
}

export type ASSET_INFO = Omit<ASSET, 'name' | '_id'>;

const defaultBalance = {
  decimals: 0,
  balance: {
    available: null,
    _available: '0',
    rate: 0,
    inUsd: null,
    _inUsd: '0',
  },
};

export const ASSETS: Record<string, ASSET_INFO> = {
  VOTE: {
    code: 'VOTE',
    ticker: 'VOTE',
    title: 'VOTE',
    icon: Vote,
    sliderStep: 1,
    smallIcon: VoteIcon,
    network: 'TON',
    colors: ['#7076ff', '#d04dac', '#ff6a49'],
    ...defaultBalance,
  },
  USDT: {
    code: 'USDT',
    ticker: 'USDT',
    title: 'USDT',
    coingeckoId: 'tether',
    sliderStep: 1,
    icon: UsdtBig,
    smallIcon: Usdt,
    network: 'TON',
    colors: ['#50af95', '#50af95', '#50af95'],
    ...defaultBalance,
  },
  TON: {
    code: 'TON',
    ticker: 'TON',
    title: 'Toncoin',
    sliderStep: 0.1,
    coingeckoId: 'the-open-network',
    icon: TonBig,
    smallIcon: Ton,
    network: 'TON',
    colors: ['#0098ea', '#0098ea', '#0098ea'],
    ...defaultBalance,
  },
  MY: {
    code: 'MY',
    ticker: 'MY',
    title: 'MyTonWallet Coin',
    sliderStep: 1,
    coinpaprikaId: 'my-mytonwallet-coin',
    icon: MyIcon,
    network: 'TON',
    smallIcon: MyIcon,
    colors: ['#0098ea', '#0098ea', '#0098ea'],
    ...defaultBalance,
  },
  USDC: {
    code: 'USDC',
    ticker: 'USDC',
    title: 'USDC',
    sliderStep: 1,
    coinpaprikaId: 'usdc-usdc',
    icon: Usdc,
    smallIcon: Usdc,
    network: 'ALGO',
    colors: ['#2671c4', '#2671c4', '#2671c4'],
    ...defaultBalance,
  },
  ALGO: {
    code: 'ALGO',
    ticker: 'ALGO',
    title: 'ALGO',
    sliderStep: 1,
    coinpaprikaId: 'algo-algorand',
    icon: Algo,
    smallIcon: Algo,
    network: 'ALGO',
    colors: ['#2671c4', '#2671c4', '#2671c4'],
    ...defaultBalance,
  },
};
